// Core
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import graphColours from 'constants/graphColours';
// Logic
import StatsLogic from '../../../Logic/StatsLogic';

import '../index.scss';
import StatsLoader from 'routes/stats/components/StatsLoader';

function MedianConversationLength(props) {
  const medianConversationLengthByDay = useSelector(
    (state) => state.statsRoute.medianConversationLengthByDay
  );
  const startDate = useSelector(
    (state) => state.statsRoute.conversationStartDateFilter
  );
  const endDate = useSelector(
    (state) => state.statsRoute.conversationEndDateFilter
  );
  const medianConversationLengthAggregate = useSelector(
    (state) => state.statsRoute.medianConversationLengthAggregate
  );

  const fetchingStats = useSelector(
    (state) =>
      state.statsRoute.fetchingConversationLengthStats &&
      state.statsRoute.fetchingConversationResponseTimeAggregate
  );

  let data = [];
  if (medianConversationLengthByDay.length) {
    const medians = StatsLogic.formatConversationStats(
      medianConversationLengthByDay,
      startDate,
      endDate
    );
    medians.forEach((responsePeriod) => {
      data.push([
        responsePeriod.label,
        responsePeriod.value,
        StatsLogic.getHumanReadableTooltipString(responsePeriod.value),
      ]);
    });
  }

  const mergedMedianTimes = data.map(([label, median]) => median);

  // Calculate the largest label for graph.
  const maximum = Math.max(...mergedMedianTimes).toFixed(1);
  const unit = StatsLogic.valueBetterAs(maximum);

  const formattedMedians = data.map(([label, median, tooltip]) => [
    label,
    StatsLogic.secondsTo(median, unit),
    tooltip,
  ]);
  const header = ['date', '', { type: 'string', role: 'tooltip' }];

  const graphData = data.length
    ? [header, ...formattedMedians]
    : [header, ['', 0, '']];

  const currentPeriodMedian = StatsLogic.getHumanReadableTooltipString(
    medianConversationLengthAggregate
  );

  const options = {
    hAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: '',
      minValue: 0,
      slantedText: true,
      slantedTextAngle: StatsLogic.getSlantedTextAngleForRange(
        props.currentPeriod
      ),
      gridlines: {
        color: '#CBD5E1',
      },
      baselineColor: '#CBD5E1',
    },
    vAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: unit.charAt(0).toUpperCase() + unit.slice(1),
      format: '#,###',
      minValue: 0,
      maxValue: 4,
      gridlines: {
        color: '#CBD5E1',
        count: -1
      },
      baselineColor: '#CBD5E1',
    },
    legend: 'none',
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: [graphColours.primary],
  };
  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader
              primary={currentPeriodMedian}
              showSecondary={false}
            />
          </div>
        </GeckoRow>
        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={options}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
}

export default MedianConversationLength;
